function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Attack");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Login-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home",
  transform: "translate(-61.000000, -612.000000)"
}, React.createElement("g", {
  id: "Attack",
  transform: "translate(61.000000, 612.000000)"
}, React.createElement("g", {
  id: "Group-3"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#1A76E2",
  cx: 8.5,
  cy: 8.5,
  r: 8.5
}), React.createElement("g", {
  id: "sword-svgrepo-com",
  transform: "translate(8.500000, 7.846154) scale(-1, 1) translate(-8.500000, -7.846154) translate(2.615385, 2.615385)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M7.43280702,6.94765866 L6.95935773,6.94765866 L7.67221433,1.90645324 C7.69139943,1.77091902 7.62590453,1.59134195 7.51989871,1.48869031 L6.08334648,0.0979113884 C6.01907097,0.0356899091 5.9283211,2.05169215e-13 5.83434662,2.05169215e-13 C5.74037214,2.05169215e-13 5.64964937,0.0356899091 5.58537386,0.0979113884 L4.14879452,1.4886673 C4.04278871,1.59131893 3.9773209,1.77091902 3.99647891,1.90643023 L4.7093355,6.94763565 L4.23588621,6.94763565 C4.00794119,6.94763565 3.82248521,7.10512226 3.82248521,7.29868997 L3.82248521,7.73552893 C3.82248521,7.92909664 4.00794119,8.08658326 4.23588621,8.08658326 L5.24169498,8.08658326 L5.24169498,8.84923358 C4.9703396,9.00915935 4.79219997,9.27546452 4.79219997,9.57658519 C4.79219997,10.0645544 5.25968779,10.4615385 5.83431952,10.4615385 C6.40895125,10.4615385 6.87643907,10.0645544 6.87643907,9.57658519 C6.87643907,9.27546452 6.69829944,9.00915935 6.42694406,8.84923358 L6.42694406,8.08658326 L7.43275283,8.08658326 C7.66069785,8.08658326 7.84615385,7.92909664 7.84615385,7.73552893 L7.84615385,7.29868997 C7.84620803,7.10512226 7.66075205,6.94765866 7.43280702,6.94765866 Z",
  id: "Path",
  transform: "translate(5.834320, 5.230769) rotate(-45.000000) translate(-5.834320, -5.230769) "
}))))));

var SvgAttack = function SvgAttack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Attack.6386358c.svg";
export { ForwardRef as ReactComponent };